import { createStyles, makeStyles, TableCell, TableRow, Theme } from '@material-ui/core';
import React from 'react';
import moment from 'moment';
import { useGlobalState } from '../../../store/GlobalStore';
import { IActivityCountReport } from '../../../models/AgentReport/IAgentActivityCountReport';

const useRowStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            fontSize: 12,
        },
        rootHidden: {
            display: "none"
        },
        collapsePadding: {
            padding: '8px'
        },
        tablefont: {
            fontSize: 12,
            padding: '5px 0px 5px 5px !important'
        }
    })
);

const AgentActivityCountExpandableRow: React.FC<{ row: IActivityCountReport }> = (props) => {
    const classes = useRowStyles();
    const { row } = props;
    const { state } = useGlobalState();

    return (
        <React.Fragment>
            <TableRow >
                <TableCell className={classes.tablefont}>{row?.clientCode}</TableCell>
                <TableCell className={classes.tablefont}>{row?.emailAddress}</TableCell>
                <TableCell className={classes.tablefont}>{row?.fullName}</TableCell>
                <TableCell className={classes.tablefont}>{row?.communicationMethod}</TableCell>
                <TableCell className={classes.tablefont}>{row?.activityName}</TableCell>
                <TableCell className={classes.tablefont}>{moment(row?.createdDate).format(state.GlobalUtils?.settingValue)}</TableCell>
                <TableCell className={classes.tablefont}>{row?.totalCount}</TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default AgentActivityCountExpandableRow;
